<template>
  <div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 text-right">
          <div v-if="!hasNoTariffId">
            <form-button
              :indicator="indicator"
              v-on:clicked="showAddHireForm"
              v-if="hasPermission('hires.create') && !readonly"
            >
              Add Hire
            </form-button>
          </div>
          <div v-else-if="hasNoTariffId" class="text-danger">
            Save Tariff to enable services
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="loading-overlay" v-if="loading"></div>
      <table class="table table-striped table-bordered table-centered">
        <thead>
          <tr>
            <th>Vehicle Registration</th>
            <th>Vehicle Group</th>
            <th>Hire Start Date</th>
            <th>Hire End Date</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!hires.length && !loading">
            <td class="text-center" colspan="5">
              There are currently no hires created for this claim
            </td>
          </tr>

          <tr v-bind:key="index" v-for="(hire, index) in hires">
            <td>
              {{
                hire.vehicle?.vehicle?.registration ||
                  hire.vehicle?.registration ||
                  'Not Provided'
              }}
            </td>
            <td>
              {{
                hire.vehicle?.vehicle?.group?.name ||
                  hire.vehicle?.group?.name ||
                  'Not Provided'
              }}
            </td>
            <td>
              {{
                hire.vehicle && hire.vehicle.start_date
                  ? formatDate(hire.vehicle.start_date)
                  : 'Not Provided'
              }}
            </td>
            <td>
              {{
                hire.vehicle && hire.vehicle.end_date
                  ? formatDate(hire.vehicle.end_date)
                  : 'Ongoing'
              }}
            </td>
            <td>
              <button
                class="btn btn-primary"
                type="button"
                v-on:click.prevent="viewHireForm(hire)"
                v-if="hasPermission('hires.update') || readonly"
              >
                View Details
              </button>
              <form-button
                :indicator="deleting"
                level="danger"
                @clicked="deleteHire(hire, index)"
                v-if="hasPermission('hires.delete') && !readonly"
              >
                Delete
              </form-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hire
      :incident="incident"
      :hire="hire"
      :modal-view="true"
      v-if="addHire"
      v-on:back="backToDeployment"
    ></hire>

    <!--<div class="card-footer text-right" v-else>-->
    <!--<button class="btn btn-primary btn-raised" name="save" v-on:click.prevent="submit">-->
    <!--<i class="icon icon-save"></i> Save-->
    <!--</button>-->
    <!--</div>-->
  </div>
</template>
<script>
import Hire from './Children/AddHire.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    hire: Hire
  },

  data() {
    return {
      party: {},
      indicator: false,
      hires: [],
      addHire: false,
      deleting: false,
      loading: true
    };
  },

  computed: {
    incidentObject() {
      return this.$store.getters['Incident/incident'];
    },
    hasNoTariffId() {
      return !this.incidentObject || !this.incidentObject.tariff_id;
    }
  },

  mounted() {
    window.Ajax.get(`/incidents/${this.incident}/parties`).then(response => {
      const clients = response.data.filter(
        party => party.type.name === 'client'
      );

      if (clients.length) {
        this.party = clients[0];

        window.Ajax.get(
          `/incidents/${this.incident}/parties/${this.party.identifier}/hires`
        ).then(response => {
          this.hires = response.data;
          this.loading = false;
        });
      }
    });
  },

  methods: {
    showAddHireForm() {
      this.indicator = true;

      window.Ajax.post(
        `/incidents/${this.incident}/parties/${this.party.identifier}/hires`
      )
        .then(response => {
          this.indicator = false;
          this.route(
            `/deployment/${this.incident}/party/${this.party.identifier}/hire/${response.data.identifier}?mode=add`
          );
        })
        .catch(error => {
          this.indicator = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an issue creating the hire'
          );
        });
    },

    viewHireForm(hire) {
      if (!hire.has_vehicle_hire_agreement) {
        this.route(
          `/deployment/${this.incident}/party/${this.party.identifier}/hire/${hire.identifier}?mode=view`
        );

        return;
      }

      this.route(
        `/deployment/${this.incident}/party/${this.party.identifier}/hire/${hire.identifier}/complete`
      );
    },

    vehicleRegistration(hire) {
      if (hire.vehicle) {
        if (hire.vehicle.vehicle) {
          return hire.vehicle.vehicle.registration;
        } else {
          return hire.vehicle.registration;
        }
      }

      return 'Not Provided';
    },

    deleteHire(hire, index) {
      this.deleting = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete that hire?',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.delete(
            `/incidents/${this.incident}/parties/${this.party.identifier}/hires/${hire.identifier}`
          )
            .then(() => {
              this.hires.splice(index, 1);

              window.toastify.success(
                'Deleted',
                'The hire was deleted successfully!'
              );

              this.deleting = false;
            })
            .catch(() => {
              window.toastify.error(
                'Sorry, there was an issue deleting the hire'
              );

              this.deleting = false;
            });
        })
        .catch(err => {
          this.deleting = false;
        });
    }
  }
};
</script>
